import React, { useEffect, useState } from 'react';
import QRcode from 'react-qr-code';
import { useNavigate, Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { FaRegCopy } from 'react-icons/fa';
import ClipboardJS from 'clipboard';

import Index from '~/pages/Index';
import check from '~/assets/img/check.svg';


import { useToast } from '~/hooks/toast';

import OrderStatusEnum from '~/enums/OrderStatusEnum';
import { useProfile } from '~/hooks/profile';

import formatValue from 'src/utils/formatValue';
import * as S from './styles';


export default function SuccessCard() {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { cardData } = useProfile();
  const [statusOrder, setStatusOrder] = useState('');
  const formatedTotal = formatValue(cardData.total);

  useEffect(() => {
    setStatusOrder(
      cardData.status_id
        ? OrderStatusEnum.properties[cardData.status_id].label
        : ''
    );
  }, [cardData]);

  const clipboard = new ClipboardJS('#buttonCopy');
  clipboard.on('success', e => {

    addToast({
      type: 'success',
      title: 'Sucesso',
      description: `Código copiado para área de transferência!`,
    });

    e.clearSelection();
  });

  clipboard.on('error', e => {
    addToast({
      type: 'error',
      title: 'Erro',
      description: `Erro ao copiar!`,
    });

    e.clearSelection();
  });


  useEffect(() => {
    if (cardData.length === 0) {
      navigate('/dashboard/inicio/resumo');
    }
  }, [cardData, navigate]);

  return (
    <Index>
      <S.SectionNotMusic>
        <div className="sucess">
          <img src={check} alt="Solicitação realizada com sucesso"/>

          <span>Solicitação realizada com sucesso!</span>
        </div>

        <div className="informationPix">
          <span className='lerQr'>Leia o QrCode</span>
          <QRcode value={cardData?.charge?.pixCopiaECola ? cardData.charge.pixCopiaECola : ""} size={200} />

          <span>Ou pague com pix copia e cola!</span>

          <span className="spanCopy">
            {cardData?.charge?.pixCopiaECola ? cardData.charge.pixCopiaECola : ""}
          </span>
          <div>
            <button
              id="buttonCopy"
              type="button"
              data-clipboard-text={cardData?.charge?.pixCopiaECola ? cardData.charge.pixCopiaECola : ""}
            >
              <FaRegCopy />
              Copiar código PIX
            </button>
          </div>

        </div>

        <div className="resume">
          <h1>Resumo:</h1>
          <Table borderless>
            <div className="orderService">
              <span>
                Transação Nº:
                <strong>
                  {' '}
                  {cardData.payment && cardData.payment.transaction
                    ? cardData.payment.transaction.transaction_id
                    : ''}
                </strong>
              </span>
            </div>
            <tbody>
              <tr>
                <td>Créditos:</td>
                <td>{cardData?.meta?.qty_items ? cardData.meta.qty_items : ""}</td>
              </tr>

              <tr>
                <td>Status:</td>
                <td>{statusOrder}</td>
              </tr>

              <tr>
                <td>Meio de pagamento:</td>
                <td>PIX</td>
              </tr>

              <tr>
                <td>Data:</td>
                <td>{cardData.created_at}</td>
              </tr>

              <tr>
                <td>Total:</td>
                <td>{formatedTotal}</td>
              </tr>
            </tbody>
          </Table>
        </div>

        <Link to="/dashboard/inicio/resumo">Voltar para o início</Link>
      </S.SectionNotMusic>
    </Index>
  );
}
